import { fillVariants } from "../../../styles/utils/fill"
import { classNames } from "../../../utils"
import type { IconProps } from "../../types"

export function Twitter({
  size = 24,
  fill = "current",
  fillAttribute = "currentColor",
  className,
  ...rest
}: IconProps) {
  return (
    <svg
      aria-label="X"
      className={classNames(fillVariants({ fill }), className)}
      fill={fillAttribute}
      height={size}
      viewBox="0 0 16 16"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="Twitter">
        <path d="M9.14163 7.19284L13.6089 2H12.5503L8.67137 6.50887L5.57328 2H2L6.68492 8.81821L2 14.2637H3.05866L7.15491 9.50218L10.4267 14.2637H14L9.14163 7.19284ZM7.69165 8.87828L7.21697 8.19934L3.44011 2.79694H5.06615L8.11412 7.15685L8.5888 7.83579L12.5508 13.503H10.9248L7.69165 8.87828Z" />
      </g>
    </svg>
  )
}
